import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { resolveCommunityForSite, resolveCommunityForMember, formatDate } from '@flexo/general';

interface InformationCardContentMembersSitesProps {
  id: string;
  description: any;
}

const InformationCardContentMembersSites: React.FC<InformationCardContentMembersSitesProps> = ({ id, description }) => {
  const { t } = useTranslation();
  const params = useParams();
  const entityId = params.id as string;

  const { entities } = useSelector((state: any) => state.metadata);
  const calendar = useSelector((state: any) => state.calendar);
  const selectedDate = calendar?.hiveCalendar?.selectedDate;
  const dateFrom = selectedDate?.[0] ? formatDate(selectedDate[0]) : '';

  const allSites = entities?.site || [];
  const allMembers = entities?.member || [];

  // Filter sites that belong to this community at the selected date (via changelog)
  const communitySites = useMemo(() => {
    if (!dateFrom || !entityId) return [];
    return allSites.filter(
      (site: any) => resolveCommunityForSite(site, dateFrom) === entityId
    );
  }, [allSites, dateFrom, entityId]);

  // Filter members that belong to this community at the selected date (via changelog)
  const communityMembers = useMemo(() => {
    if (!dateFrom || !entityId) return [];
    return allMembers.filter(
      (member: any) => resolveCommunityForMember(member, dateFrom) === entityId
    );
  }, [allMembers, dateFrom, entityId]);

  const siteTypeCounts: Record<string, number | null> = {
    consumer: 0,
    producer: 0,
    prosumer: 0,
    prosumage: 0,
  };

  communitySites.forEach((site: any) => {
    if (Array.isArray(site.siteType)) {
      site.siteType.forEach((type: any) => {
        if (
          type.siteType &&
          Object.prototype.hasOwnProperty.call(siteTypeCounts, type.siteType)
        ) {
          siteTypeCounts[type.siteType]!++;
        }
      });
    } else if (typeof site.siteType === 'string') {
      if (Object.prototype.hasOwnProperty.call(siteTypeCounts, site.siteType)) {
        siteTypeCounts[site.siteType]!++;
      }
    }
  });

  for (const key in siteTypeCounts) {
    if (siteTypeCounts[key] === 0) {
      siteTypeCounts[key] = null;
    }
  }

  const keys = description.map((el: any) => el.key.split('.').slice(-1).pop());

  return (
    <>
      {keys
        .filter((el: any) => siteTypeCounts[el] !== null)
        .map((siteType: string, i: number, array: any) => {
          const label = description.find((desc: any) => desc.key.includes(siteType));
          return (
            <span key={`${id}-label-value-label-value-${i}`} className="paragraph" style={{marginBottom: '0px'}}>
              {t(label.key)}: {siteTypeCounts[siteType]}{' '}
              {i < array.length - 1 ? '|' : ''}&nbsp;
            </span>
          );
        })}
      <div className={'paragraph'}>{t('widgets.communitySitesCard.members')}:{' '}{communityMembers.length}</div>
    </>
  );
};


export default InformationCardContentMembersSites; 